// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30jlT","col":"styles_col__Sxbp1"};